module.exports = "i.pendent{color:grey}i.acceptada{color:green}i.desestimada{color:red}i.denuncia{color:orange}i.pendent-validacio{color:orange}\n"